import React from 'react';
import {
    fetchItemById,
    fetchSearchItems
} from '../../pages/editors/helper/fetchSearchItems';
import i18n from '../../i18n';
import FormControl from '@mui/material/FormControl';
import debounce from 'lodash/debounce';
import Autocomplete from '@mui/material/Autocomplete';
import { CircularProgress, TextField } from '@mui/material';
import { AppDataContext } from '../../context/Context';
import { normalizeOptions } from './helpers';

export default class SearchSelect extends React.Component {
    static contextType = AppDataContext;

    constructor(props) {
        super(props);
        this.state = {
            options: props.options || [],
            inputValue: '',
            loading: false
        };
        this.debouncedFetchOptions = debounce(this.fetchOptions, 600);
    }

    componentDidMount() {
        this.state.options.length === 0 && this.fetchOptions('', true);
        if (this.props.value !== null) {
            const exist = this.state.options.find(
                (option) => option.id === this.props.value
            );
            if (!exist) {
                this.fetchSelectedOption(this.props.value);
            }
        }
    }

    fetchSelectedOption = async (value) => {
        this.setState({ loading: true });
        const server =
            this.context.getState().server[this.props.searchController];
        const result = await fetchItemById(
            value,
            server,
            this.props.prefilterRequest
        );
        if (
            result.error === 'OK' &&
            Array.isArray(result.data) &&
            result.data.length > 0
        ) {
            const options = normalizeOptions(
                result.data,
                this.props.searchFields
            );
            this.setState((prevState) => ({
                options: [...prevState.options, ...options]
            }));
        }
        this.setState({ loading: false });
    };

    componentWillUnmount() {
        this.setState({
            options: [],
            inputValue: '',
            loading: false
        });
        this.debouncedFetchOptions.cancel();
    }

    fetchOptions = async (query, mount = false) => {
        const q = (query || '').trim();
        if (!q && !mount) return;

        this.setState({ loading: true });
        const server =
            this.context.getState().server[this.props.searchController];
        const searchFields = this.props.searchFields;

        try {
            const res = await fetchSearchItems(
                searchFields,
                q,
                server,
                20,
                this.props.prefilterRequest || []
            );
            if (res.error !== 'OK') {
                throw new Error('Error fetching options');
            }
            const options = normalizeOptions(res.data, searchFields);
            this.setState({ options });
        } catch (error) {
            console.error('Error fetching options:', error);
            this.setState({ options: [] });
        } finally {
            this.setState({ loading: false });
        }
    };

    handleInputChange = (event, newInputValue, reason) => {
        if (reason === 'reset' || reason === 'clear' || reason === 'blur') {
            this.setState({
                inputValue: newInputValue || ''
                // options: this.props.options || []
            });
            return;
        }
        const q = (newInputValue || '').trim();
        this.setState({ inputValue: q });
        if (q.length > 0) {
            this.debouncedFetchOptions(q);
        }
    };

    handleChanged = (field, option) => {
        if (option === null) {
            this.props.onChange(field, null);
        } else {
            this.props.onChange(field, option.id);
        }
    };

    render() {
        const { label, id, value } = this.props;
        const { options, loading, inputValue } = this.state;

        const translatedName = i18n.t(`columns.${label}`);
        return (
            <FormControl fullWidth sx={{ mt: 1 }}>
                <Autocomplete
                    disabled={this.props.disabled}
                    inputValue={inputValue}
                    value={options.find((item) => item.id === value) || null}
                    onChange={(event, newValue) => {
                        this.handleChanged(id, newValue);
                    }}
                    onInputChange={this.handleInputChange}
                    options={options}
                    loading={loading}
                    getOptionLabel={(option) => option.value || ''}
                    renderOption={(optionProps, option) => (
                        <li {...optionProps} key={option.id}>
                            {option.value}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={translatedName}
                            variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading ? (
                                            <CircularProgress
                                                color="inherit"
                                                size={20}
                                            />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                )
                            }}
                        />
                    )}
                />
            </FormControl>
        );
    }
}
